/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorpanel_Troubleshoot_Step3title2Inputs */

const en_errorpanel_troubleshoot_step3title2 = /** @type {(inputs: Errorpanel_Troubleshoot_Step3title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again later`)
};

/**
* | output |
* | --- |
* | "Try again later" |
*
* @param {Errorpanel_Troubleshoot_Step3title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errorpanel_troubleshoot_step3title2 = /** @type {((inputs?: Errorpanel_Troubleshoot_Step3title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorpanel_Troubleshoot_Step3title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errorpanel_troubleshoot_step3title2(inputs)
});
export { errorpanel_troubleshoot_step3title2 as "errorPanel_troubleshoot_step3Title" }